/**
 * Maps to FlagSmith ID
 * @const {string}
 */
// eslint-disable-next-line import/prefer-default-export
export const NEXTGEN_ACCESS = 'nextgen_access';
